import React from 'react';
import Helmet from 'react-helmet';
import _ from 'lodash';

import InOutDashboardStore from '../services/inOutDashboard/InOutDashboardStore';
import InOutDashboardContext from '../services/inOutDashboard/InOutDashboardContext';
import ClosedBillingMonthSelectDialog from '../components/modals/ClosedBiilingMonthSelectDialog';
import dialogLoader from '../utilities/dialogLoader';
import { FieldTableLayout } from '../components/tables/InOutDashboardFieldTable';
import { RecordTableLayout } from '../components/tables/InOutDashboardRecordTable';
import { NewsList } from '../components/list/InOutDashboardNewsList';
import { MonthlyRecordTableLayout } from '../components/tables/InOutDashboardMonthlyRecordTable';
import Information from '../components/modals/common/Information';
import LocalStorageService from '../services/utilities/LocalStorageService';

import { messageUtility } from '../utilities/messageUtility';
import { isLoginUserPrimaryCompany } from '../utilities/roleUtility';

import Styles from '../styles/componentStyle/inOutDashboard/InOutDashboard.scss';

/**
 * ダッシュボード画面
 */
export class InOutDashboard extends React.Component {
  // 画面表示
  render() {
    return (
      <InOutDashboardStore>
        <InOutDashboardContext.Consumer>
          {({
            state,
            handleClickMonthBillingDialog,
            closeNotExistFieldIdDialog,
            goToUnidentifiedCheckInOutLogs,
            closeErrorDialog,
          }) => (
            <React.Fragment>
              <div id='main' className='main'>
                <Helmet title={data.title} />
                <div className='main__header'>
                  <h1>{data.title}</h1>
                </div>

                <div className={`${Styles.mainBody} main__body`}>
                  <div className='dashboard'>
                    <div className='dashboard__wrapper'>
                      <div className='dashboard__section'>
                        <div className='dashboard__section-title'>
                          {data.sectionTitle.fieldDetail}
                        </div>
                        <FieldTableLayout />
                      </div>
                      <div className='dashboard__section'>
                        <div className='dashboard__section-title'>
                          {data.sectionTitle.inOutRecord}
                        </div>
                        <RecordTableLayout />

                        {state.unidentifiedTotal !== 0 && (
                          <div className='unidentified_message_wrapper'>
                            <p className='unidentified_message'>
                              {messageUtility.getMessage('I-002-008-01')}(
                              {state.unidentifiedTotal}件)
                            </p>
                            <button
                              className='btn--contained'
                              onClick={() => goToUnidentifiedCheckInOutLogs()}
                            >
                              確認
                            </button>
                          </div>
                        )}

                        {state.unapprovedTotal !== 0 && (
                          <p className='unapproved_message'>
                            {messageUtility.getMessage('I-002-008-02')}(
                            {state.unapprovedTotal}件)
                          </p>
                        )}

                        {state.accumurationErrorFlag && (
                            <p className='accumuration_error_message'>
                              {messageUtility.getMessage('I-002-013-07')}
                            </p>
                        )}

                        {isLoginUserPrimaryCompany() &&
                          state.showMonthlyRecordTableFlag &&
                          state.faceImageHistories
                            .last_month_register_image_count !== null &&
                          state.faceImageHistories
                            .current_month_register_image_count !== null && (
                            <React.Fragment>
                              <div
                                className='dashboard__section-title'
                                style={{ marginTop: '20px' }}
                              >
                                {data.sectionTitle.monthlyRecord}
                              </div>
                              <MonthlyRecordTableLayout />
                              <div className='exp-text'>
                                月次実績に表示されている件数は、出勤日が該当月の入退場実績の件数になります。
                                <br />
                                確定した請求件数については「過去の顔レコ利用記録をExcel出力する」で確認することができます。
                              </div>
                              <div className='btn-menu__item dashboard-excel-button__section'>
                                <button
                                  className={
                                    state.faceImageHistories
                                      .is_used_face_api === 1
                                      ? data.buttonTitle
                                          .effectiveButtonClassName
                                      : data.buttonTitle.disabledButtonClassName
                                  }
                                  disabled={
                                    state.faceImageHistories
                                      .is_used_face_api !== 1
                                  }
                                  onClick={() =>
                                    handleClickMonthBillingDialog()
                                  }
                                >
                                  {data.buttonTitle.downloadExcel}
                                </button>
                              </div>
                            </React.Fragment>
                          )}
                      </div>
                    </div>
                    {(!_.isEmpty(state.newsList) || state.ccusSecededWarning) && (
                      <div className='dashboard__section'>
                        <div className='dashboard__section-title'>
                          {data.sectionTitle.information}
                        </div>
                        <NewsList />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <Information
                message={messageUtility.getMessage('E-002-001-006')}
                buttonText={messageUtility.getMessage('I-000-017')}
                visible={state.isShowNotExistFieldIdDialog}
                onClose={() => closeNotExistFieldIdDialog()}
              />

              <Information
                visible={state.errorDialogStatus === true}
                message={state.failDialog.message}
                buttonText={data.buttonTitle.back}
                onClose={() => closeErrorDialog()}
                multilineText={true}
              />
            </React.Fragment>
          )}
        </InOutDashboardContext.Consumer>
      </InOutDashboardStore>
    );
  }
}

// 定数
const data = {
  title: 'ダッシュボード',
  sectionTitle: {
    fieldDetail: '現場詳細',
    inOutRecord: '入退場実績',
    information: 'お知らせ',
    monthlyRecord: '月次実績',
  },
  buttonTitle: {
    close: '閉じる',
    downloadExcel: '過去の顔レコ利用記録をExcel出力する',
    back: '戻る',
    disabledButtonClassName: 'btn--disabled',
    effectiveButtonClassName: 'btn--sub',
  },
};



// WEBPACK FOOTER //
// ./src/pages/InOutDashboard.jsx